import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSearch(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10 4a6 6 0 1 0 3.476 10.89l4.817 4.817a1 1 0 0 0 1.414-1.414l-4.816-4.816A6 6 0 0 0 10 4Zm-4 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
